import * as React from "react";
import {Option} from "ts-option";
import Col from "../../layout/Col";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import DatePickerComponent from "../../ui/datepicker/DatePickerComponent";
import * as moment from 'moment';
import DateUtils from "../../../utils/DateUtils";

interface ComponentProps {
	/**
	 * Update custom field value action.
	 * @param {string} updatedValue
	 */
	updateCustomFieldValue: (updatedValue: string) => void;
	/**
	 * Remove custom field value action.
	 */
	removeCustomFieldValue: () => void;
	/**
	 * Custom field label
	 */
	label: string;
	/**
	 * Custom field value
	 */
	value: Option<moment.Moment>
}

export default class DateInFormDisplay extends React.Component<ComponentProps> {

	render() {
		return (
			<Col md={12} lg={4} xl={4} style={{paddingBottom: '30px'}}>
				<FormGroup label={this.props.label}
						   customClass={"c-date-picker-form-group"}>
					<DatePickerComponent value={this.props.value}
										 onChange={this.onChange}
										 clearable={true}/>
				</FormGroup>
			</Col>
		);
	}

	onChange = (date: Option<moment.Moment>) => {
		if(date.isDefined) {
			this.props.updateCustomFieldValue(date.map(d => d.format(DateUtils.ISO_DATE_FORMAT)).getOrElse(''));
		} else {
			this.props.removeCustomFieldValue();
		}
	}
}